import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12 p-md-3" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-2 p-lg-2" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_7 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-2 p-lg-2" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_10 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_11 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_12 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_18 = { id: "loadingExport" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createBlock(_component_Accordion, { activeIndex: 0 }, {
    default: _withCtx(() => [
      _createVNode(_component_AccordionTab, { header: "Thống kê CheckIn/CheckOut theo tháng" }, {
        default: _withCtx(() => [
          _createVNode(_component_Panel, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_Calendar, {
                    id: "dateMonth",
                    modelValue: $setup.dateMonth,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dateMonth) = $event)),
                    selectionMode: "single",
                    view: "month",
                    dateFormat: "mm/yy",
                    showButtonBar: true,
                    showIcon: true,
                    manualInput: false,
                    monthNavigator: true,
                    yearNavigator: true,
                    yearRange: "2000:2100",
                    onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectCalendar())),
                    onClearClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearCalendar()))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_Dropdown, {
                    modelValue: $setup.idDepartment,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.idDepartment) = $event)),
                    options: $setup.listDepartment,
                    optionLabel: "name",
                    optionValue: "id",
                    placeholder: "Chọn khoa/ phòng",
                    filter: true
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Button, {
                    label: "Xử lý",
                    icon: "pi pi-spinner",
                    iconPos: "left",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.exportFileMonth())),
                    disabled: $setup.dateMonth
                  }, null, 8, ["disabled"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    label: "Tải danh sách",
                    icon: "pi pi-download",
                    iconPos: "left",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.downLoadFileExport($setup.fileNameMonth, 1))),
                    disabled: !$setup.downloadFile
                  }, null, 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_AccordionTab, { header: "Thống kê CheckIn/CheckOut chi tiết theo ngày" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Calendar, {
                id: "date",
                modelValue: $setup.date,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.date) = $event)),
                selectionMode: "single",
                dateFormat: "dd/mm/yy",
                showButtonBar: true,
                showIcon: true,
                manualInput: false,
                monthNavigator: true,
                yearNavigator: true,
                yearRange: "2000:2100",
                onDateSelect: _cache[7] || (_cache[7] = ($event: any) => ($setup.selectCalendar())),
                onClearClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.clearCalendar()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Button, {
                label: "Xử lý",
                icon: "pi pi-spinner",
                iconPos: "left",
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.exportFile())),
                disabled: $setup.listThongKeDiemDanh.length < 1
              }, null, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, {
                label: "Tải danh sách",
                icon: "pi pi-download",
                iconPos: "left",
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.downLoadFileExport($setup.fileName, 0))),
                disabled: !$setup.downloadFile
              }, null, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_DataTable, {
                value: $setup.listThongKeDiemDanh,
                paginator: true,
                stripedRows: "",
                rows: 10,
                rowsPerPageOptions: [10,50,150],
                rowHover: true,
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                globalFilterFields: ['fullName','phoneNumber','team'],
                showGridlines: "",
                currentPageReportTemplate: "Có tất cả {totalRecords} dữ liệu",
                filters: $setup.filters,
                "onUpdate:filters": _cache[13] || (_cache[13] = ($event: any) => (($setup.filters) = $event)),
                style: {"font-size":"13px"}
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Xoá",
                      class: "p-button-outlined",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.clearFilter())),
                      style: {"width":"6em"}
                    }),
                    _createElementVNode("span", _hoisted_12, [
                      _cache[15] || (_cache[15] = _createElementVNode("i", { class: "pi pi-search" }, null, -1)),
                      _createVNode(_component_InputText, {
                        modelValue: $setup.filters['global'].value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.filters['global'].value) = $event)),
                        placeholder: "Tìm theo tên hoặc số điện thoại"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                empty: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createTextVNode(" Không có thông tin CheckIn/CheckOut. ")
                ])),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "fullName",
                    header: "Họ và tên",
                    sortable: "",
                    style: {"font-weight":"bolder"}
                  }),
                  _createVNode(_component_Column, {
                    field: "phoneNumber",
                    header: "Số điện thoại",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "team",
                    header: "Khoa/ Phòng",
                    style: {"font-weight":"bolder"},
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "checkInMorning",
                    header: "Checkin sáng",
                    sortable: "",
                    style: {"width":"150px"}
                  }, {
                    body: _withCtx(({data}) => [
                      (data.checkInMorningImage)
                        ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                            title: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode(" Checkin sáng ")
                            ])),
                            content: _withCtx(() => [
                              _createVNode(_component_Image, {
                                src: data.checkInMorningImage,
                                alt: data.checkInMorningImage,
                                width: "150",
                                preview: ""
                              }, null, 8, ["src", "alt"])
                            ]),
                            footer: _withCtx(() => [
                              _createVNode(_component_Tag, {
                                value: $setup.formatDateTime(data.checkInMorning),
                                severity: "success"
                              }, null, 8, ["value"])
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_Tag, {
                              value: "Không có dữ liệu",
                              severity: "danger"
                            })
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "checkInMorningLatest",
                    dataType: "date",
                    header: "Checkin sáng đi trễ",
                    sortable: "",
                    style: {"width":"150px"}
                  }, {
                    body: _withCtx(({data}) => [
                      (data.checkInMorningLatestImage)
                        ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                            title: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode(" Checkin sáng đi trễ")
                            ])),
                            content: _withCtx(() => [
                              _createVNode(_component_Image, {
                                src: data.checkInMorningLatestImage,
                                alt: data.checkInMorningLatestImage,
                                width: "150",
                                preview: ""
                              }, null, 8, ["src", "alt"])
                            ]),
                            footer: _withCtx(() => [
                              _createVNode(_component_Tag, {
                                value: $setup.formatDateTime(data.checkInMorningLatest),
                                severity: "danger"
                              }, null, 8, ["value"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "checkOutMorning",
                    dataType: "date",
                    header: "Checkout sáng",
                    sortable: "",
                    style: {"width":"150px"}
                  }, {
                    body: _withCtx(({data}) => [
                      (data.checkOutMorningImage)
                        ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                            title: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" Checkout sáng")
                            ])),
                            content: _withCtx(() => [
                              _createVNode(_component_Image, {
                                src: data.checkOutMorningImage,
                                alt: data.checkOutMorningImage,
                                width: "150",
                                preview: ""
                              }, null, 8, ["src", "alt"])
                            ]),
                            footer: _withCtx(() => [
                              _createVNode(_component_Tag, {
                                value: $setup.formatDateTime(data.checkOutMorning),
                                severity: "warning"
                              }, null, 8, ["value"])
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_Tag, {
                              value: "Không có dữ liệu",
                              severity: "danger"
                            })
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "checkInAfternoon",
                    dataType: "date",
                    header: "Checkin chiều",
                    sortable: "",
                    style: {"width":"150px"}
                  }, {
                    body: _withCtx(({data}) => [
                      (data.checkInAfternoonImage)
                        ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                            title: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode(" Checkin chiều")
                            ])),
                            content: _withCtx(() => [
                              _createVNode(_component_Image, {
                                src: data.checkInAfternoonImage,
                                alt: data.checkInAfternoonImage,
                                width: "150",
                                preview: ""
                              }, null, 8, ["src", "alt"])
                            ]),
                            footer: _withCtx(() => [
                              _createVNode(_component_Tag, {
                                value: $setup.formatDateTime(data.checkInAfternoon),
                                severity: "success"
                              }, null, 8, ["value"])
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_Tag, {
                              value: "Không có dữ liệu",
                              severity: "danger"
                            })
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "checkInAfternoonLatest",
                    dataType: "date",
                    header: "Checkin chiều đi trễ",
                    sortable: "",
                    style: {"width":"150px"}
                  }, {
                    body: _withCtx(({data}) => [
                      (data.checkInAfternoonLatestImage)
                        ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                            title: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode(" Checkin chiều đi trễ")
                            ])),
                            content: _withCtx(() => [
                              _createVNode(_component_Image, {
                                src: data.checkInAfternoonLatestImage,
                                alt: data.checkInAfternoonLatestImage,
                                width: "150",
                                preview: ""
                              }, null, 8, ["src", "alt"])
                            ]),
                            footer: _withCtx(() => [
                              _createVNode(_component_Tag, {
                                value: $setup.formatDateTime(data.checkInAfternoonLatest),
                                severity: "danger"
                              }, null, 8, ["value"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "checkOutAfternoon",
                    dataType: "date",
                    header: "Checkout chiều",
                    sortable: "",
                    style: {"width":"150px"}
                  }, {
                    body: _withCtx(({data}) => [
                      (data.checkOutAfternoonImage)
                        ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                            title: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode(" Checkout chiều")
                            ])),
                            content: _withCtx(() => [
                              _createVNode(_component_Image, {
                                src: data.checkOutAfternoonImage,
                                alt: data.checkOutAfternoonImage,
                                width: "150",
                                preview: ""
                              }, null, 8, ["src", "alt"])
                            ]),
                            footer: _withCtx(() => [
                              _createVNode(_component_Tag, {
                                value: $setup.formatDateTime(data.checkOutAfternoon),
                                severity: "warning"
                              }, null, 8, ["value"])
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_Tag, {
                              value: "Không có dữ liệu",
                              severity: "danger"
                            })
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ColumnGroup, { type: "footer" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            footer: "Tổng cộng:",
                            colspan: 3,
                            footerStyle: "text-align:right"
                          }),
                          _createVNode(_component_Column, { footer: $setup.checkInMorningCount }, null, 8, ["footer"]),
                          _createVNode(_component_Column, { footer: "" }),
                          _createVNode(_component_Column, { footer: $setup.checkOutMorningCount }, null, 8, ["footer"]),
                          _createVNode(_component_Column, { footer: $setup.checkInAfternoonCount }, null, 8, ["footer"]),
                          _createVNode(_component_Column, { footer: "" }),
                          _createVNode(_component_Column, { footer: $setup.checkOutAfternoonCount }, null, 8, ["footer"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "filters"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Dialog, {
                header: "Đang xử lý",
                visible: $setup.loadingData,
                "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => (($setup.loadingData) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", null, "Đang tải dữ liệu, vui lòng chờ...", -1)),
                    _createVNode(_component_ProgressBar, {
                      mode: "indeterminate",
                      style: {"height":".3em"}
                    })
                  ])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_ConfirmDialog)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}